import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-theme/utils';

export const ICON_CLASS_NAME = 'Icon';
export const ICON_CLASS_SLOTS: Array<keyof IconClasses> = ['root'] as const;

export type IconClassSlot = (typeof ICON_CLASS_SLOTS)[number];

export interface IconClasses {
	root: string;
}

export type IconClassKey = keyof IconClasses;

export const getIconUtilityClass = (slot: string) =>
	generateUtilityClass(ICON_CLASS_NAME, slot as IconClassSlot);

export const iconClasses: IconClasses = generateUtilityClasses(
	ICON_CLASS_NAME,
	ICON_CLASS_SLOTS.concat([]),
);

export default iconClasses;
